import { UserEnums } from '@project44-models/iam-gateway';

import { UserCreationFormTemplate } from '../UserCreationFormTemplate';

export class AuthAdminUserCreatorTemplate extends UserCreationFormTemplate {
  public availableUserTypes = [
    UserEnums.UserTypeEnum.SYSTEM_USER,
    UserEnums.UserTypeEnum.USER,
    UserEnums.UserTypeEnum.CONTACT_PERSON,
    UserEnums.UserTypeEnum.CUSTOMER_INTEGRATION_USER,
  ];

  public static readonly create = (): UserCreationFormTemplate => {
    return new AuthAdminUserCreatorTemplate();
  };
}
